import { render, staticRenderFns } from "./AccettazioneSsnListaComponentOlda.vue?vue&type=template&id=51b5eece&scoped=true"
import script from "./AccettazioneSsnListaComponentOlda.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaComponentOlda.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnListaComponentOlda.vue?vue&type=style&index=0&id=51b5eece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5eece",
  null
  
)

export default component.exports